module.exports = __webpack_public_path__ + "img/kt-logo.c35216a.svg";